import { createSelector } from "reselect"
import { filter } from "lodash"
import { CATEGORIES } from "helpers/analyzeConstants"
import { getSecurity } from "modules/security-profile/selectors"

export const getFilteredOptions = createSelector([getSecurity], ({ assetClass }) => {
  return filter(CATEGORIES, o => o.id !== "concentration" || assetClass === "swap")
})
